let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2hhbf")).then(() => parcelRequire('lqqW1'));